// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `in-button {
  margin-left: 0.5em;
}

in-button {
  margin-left: 0.5em;
}

.hide {
  display: none;
}

.form-panel_header {
  display: flex;
  padding: 6px 0;
  flex-direction: row;
  flex: 0 0 auto;
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  align-items: center;
}
.form-panel_header .form-panel_title {
  flex: 1 1 auto;
  overflow: hidden;
}
.form-panel_header .form-panel_title-value {
  width: 100%;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.form-panel_header .form-panel_buttons {
  flex: 0 0 auto;
  display: flex;
  padding-right: 54px;
}

.constraints-message__warning {
  color: yellow;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
